import { render } from "./ProductCategoryFileUploadComponent.vue?vue&type=template&id=758a0e86"
import script from "./ProductCategoryFileUploadComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryFileUploadComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductCategory/ProductCategoryFileUploadComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "758a0e86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('758a0e86', __exports__)) {
    api.reload('758a0e86', __exports__)
  }
  
  module.hot.accept("./ProductCategoryFileUploadComponent.vue?vue&type=template&id=758a0e86", () => {
    api.rerender('758a0e86', render)
  })

}


export default __exports__